import { SUGGESTED_TAB } from 'context/reducers/tabs.type';
import { useAppContext } from 'hooks/useAppContext';
import { useGlobals } from 'hooks/useGlobals';
import { ProductCombo } from 'hooks/useUserCombo/types';

const usePayPerUseExtraTruckers = () => {
  const {
    state: {
      truckers: { meta },
      tabs: { activeTab },
    },
  } = useAppContext();

  const globals = useGlobals();

  const suggestedTruckersSlug =
    globals?.user?.data?.company?.combo?.products?.find(
      (product: ProductCombo) => product.slug === 'suggested-trucker'
    ) || {};

  const hasConsumed = meta?.extrasTruckers?.hasConsumed;
  const freeAvailable = meta?.extrasTruckers?.consumption?.freeAvailable;
  const freeLimit = meta?.extrasTruckers?.consumption?.freeLimit;
  const totalConsumption = meta?.extrasTruckers?.consumption?.consumed;
  const extraConsumption = totalConsumption > freeLimit ? totalConsumption - freeLimit : 0;
  const price = suggestedTruckersSlug?.price;
  const lockedTruckersAmount = meta?.truckersLimitsTotal?.locked;
  const unlockedTruckersAmount = meta?.truckersLimitsTotal?.unlocked;
  const renewalDay: number = globals?.user?.data?.company?.combo?.renew_day;
  const isFreeAvailableEmpty = freeAvailable === 0;
  const isPayPerUsePlan = suggestedTruckersSlug.allowExtra;
  const hasLockedTruckers = meta?.truckersLimitsTotal?.locked > 0;
  const showPurchaseExtraTruckersButton = isPayPerUsePlan && hasLockedTruckers && activeTab === SUGGESTED_TAB;

  return {
    isPayPerUsePlan,
    showPurchaseExtraTruckersButton,
    freeAvailable,
    freeLimit,
    extraConsumption,
    hasConsumed,
    price,
    lockedTruckersAmount,
    unlockedTruckersAmount,
    renewalDay,
    isFreeAvailableEmpty,
    hasLockedTruckers,
  };
};

export { usePayPerUseExtraTruckers };
